"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArithmeticError = exports.FormulaError = void 0;
/**
 * A generic Excel-like error that may be thrown during formula evaluation.
 */
var FormulaError = /** @class */ (function (_super) {
    __extends(FormulaError, _super);
    function FormulaError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, FormulaError.prototype);
        return _this;
    }
    Object.defineProperty(FormulaError.prototype, "errorValue", {
        get: function () {
            return "#ERROR!";
        },
        enumerable: false,
        configurable: true
    });
    return FormulaError;
}(Error));
exports.FormulaError = FormulaError;
/**
 * An error thrown when an invalid arithmetic operation (e.g. dividing by zero) is attempted.
 */
var ArithmeticError = /** @class */ (function (_super) {
    __extends(ArithmeticError, _super);
    function ArithmeticError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ArithmeticError.prototype);
        return _this;
    }
    Object.defineProperty(ArithmeticError.prototype, "errorValue", {
        get: function () {
            return this.message;
        },
        enumerable: false,
        configurable: true
    });
    return ArithmeticError;
}(Error));
exports.ArithmeticError = ArithmeticError;
//# sourceMappingURL=errors.js.map